enum MasterCustomizeTypes {
  realityAudio = 'realityAudio',
  metadata = 'metadata',
  stemFiles = 'stemFiles',
  media = 'media',
  contracts = 'contracts',
}

export default MasterCustomizeTypes;
